import component from './component/texts.js';
import exciter from './exciter/texts.js';
import exciterBeam from './exciterBeam/texts.js';
import sensor from './sensor/texts.js';
import transceiver from './transceiver/texts.js';

export default {
  equipmentConfiguration: {
    header: {
      notes: 'Header for section Equipment configuration for screens',
      message: 'Equipment configuration',
    },
    screenSubHeader: {
      notes: 'Sub header for section Screen',
      message: 'Screen',
    },
    beamsSubHeader: {
      notes: 'Sub header for section Exciter beams',
      message: 'Exciter beams',
    },
    excitersSubHeader: {
      notes: 'Sub header for section Exciters',
      message: 'Exciters',
    },
    noExciterBeams: {
      notes: 'Empty state content when no exciter beams has been created',
      message: 'No exciter beams exists.',
    },
    removeExciterBeamsButton: {
      title: {
        notes: 'Title on button that removes exciter beams',
        message: 'Remove',
      },
      confirm: {
        notes: 'Label for confirming exciter beams removal',
        message:
          'Confirm exciter beams removal (this will also remove exciters)',
      },
    },
    noExciters: {
      notes: 'Empty state content when no exciters has been created',
      message: 'No exciters exists.',
    },
    removeExcitersButton: {
      title: {
        notes: 'Title on button that removes exciters',
        message: 'Remove',
      },
      confirm: {
        notes: 'Label for confirming exciters removal',
        message: 'Confirm exciters removal',
      },
    },
  },
  systemConfiguration: {
    header: {
      notes: 'Header for section System configuration for screens',
      message: 'System configuration',
    },
    systemSubHeader: {
      notes: 'Sub header for section System',
      message: 'System',
    },
    gatewaySubHeader: {
      notes: 'Sub header for section Gateway & transceivers',
      message: 'Gateway & transceivers',
    },
    transceiversSubHeader: {
      notes: 'Sub header for section Transceivers',
      message: 'Transceivers',
    },
    noTransceivers: {
      notes: 'Empty state content when no transceivers has been created',
      message: 'No transceivers exists.',
    },
    removeTransceiversButton: {
      title: {
        notes: 'Title on button that removes transceivers',
        message: 'Remove',
      },
      confirm: {
        notes: 'Label for confirming transceivers removal',
        message: 'Confirm transceivers removal',
      },
    },
    fieldbusSubHeader: {
      notes: 'Sub header for section Fieldbus',
      message: 'Fieldbus',
    },
  },
  sensorConfiguration: {
    header: {
      notes: 'Header for section Sensor configuration for screens',
      message: 'Sensor configuration',
    },
    motionSensorsSubHeader: {
      notes: 'Sub header for section Motion sensors',
      message: 'Motion sensors',
    },
    exciterSensorsSubHeader: {
      notes: 'Sub header for section Exciter sensors',
      message: 'Exciter sensors',
    },
    removeButton: {
      title: {
        notes: 'Title on button that removes sensors',
        message: 'Remove',
      },
      confirm: {
        notes: 'Label for confirming sensor removal',
        message: 'Confirm sensor removal',
      },
    },
    empty: {
      noMotionSensors: {
        notes: 'Empty state content when no motion sensors has been created',
        message: 'No motion sensors exists.',
      },
      addMotionSensorsDisabled: {
        notes: 'Empty state content when adding motion sensors is disabled',
        message:
          'No motion sensors exists. Before adding sensors, transceivers has to be added.',
      },
      noExciterSensors: {
        notes: 'Empty state content when no exciter sensors has been created',
        message: 'No exciter sensors exists.',
      },
      addExciterSensorsDisabled: {
        notes: 'Empty state content when adding exciter sensors is disabled',
        message:
          'No exciter sensors exists. Before adding sensors, exciters and transceivers has to be added.',
      },
      addSensors: {
        notes: 'Button title for add sensors button',
        message: {
          one: 'Add 1 sensor',
          other: 'Add {{count}} sensors',
        },
      },
    },
    readOnlyWarning: {
      notes:
        'Little i text with warning that some configuration will be read-only when sensors are created',
      message:
        'When sensors have been added, some properties for exciters and transceivers will become read-only.',
    },
    readOnlyDueToSensors: {
      notes:
        'Little i text that are displayed where configuration is read-only due to existing sensors',
      message:
        'Some properties are read-only due to existing sensors that are depending on the configuration.',
    },
  },
  model: {
    screenType: {
      notes: 'Label for Screen type',
      message: 'Screen type',
      values: {
        banana: {
          notes: 'Screen type banana',
          message: 'Banana',
        },
        flat: {
          notes: 'Screen type flat',
          message: 'Flat',
        },
      },
    },
    vibrationType: {
      notes: 'Label for Vibration type for a screen',
      message: 'Vibration type',
      values: {
        linear: {
          notes: 'Vibration type linear',
          message: 'Linear',
        },
        circular: {
          notes: 'Vibration type circular',
          message: 'Circular',
        },
      },
    },
    numberOfDecks: {
      notes: 'Label for Number of decks for a screen',
      message: 'Number of decks',
      values: {
        single: {
          notes: 'Screen with 1 deck',
          message: 'Single',
        },
        double: {
          notes: 'Screen with 2 decks',
          message: 'Double',
        },
      },
    },
    numberOfExciterBeams: {
      notes: 'Label for Number of exciter beams',
      message: 'Number of exciter beams',
    },
    numberOfExciters: {
      notes: 'Label for Number of exciters',
      message: 'Number of exciters',
    },
    exciterBeam,
    exciter,
    defaultSensorModel: {
      notes: 'Label default sensor model',
      message: 'Sensor model',
    },
    motionSensorConfiguration: {
      notes: 'Label for motion sensor configuration',
      message: 'Motion sensor configuration',
    },
    exciterSensorConfiguration: {
      notes: 'Label for exciter sensor configuration',
      message: 'Exciter sensor configuration',
    },
    sensorConfigurationValue: {
      notes: 'Value text for sensor configuration',
      message: {
        zero: '-',
        one: '1 sensor',
        other: '{{numberOfSensors}} sensors',
      },
    },
    gatewayId: {
      notes: 'Label for gateway id',
      message: 'Gateway ID',
      placeholder: {
        notes: 'Placeholder for gateway id input',
        message: 'ACSGW*****',
      },
      invalidFormat: {
        notes: 'Validation error for invalid gateway id',
        message: 'Gateway ID must have the format ACSGW*****',
      },
    },
    numberOfTransceivers: {
      notes: 'Label for Number of transceivers',
      message: 'Number of transceivers',
    },
    transceiver,
    sensor,
    fieldbus: {
      notes: 'Label for Fieldbus',
      message: 'Fieldbus',
      enabled: {
        notes: 'Fieldbus enabled value',
        message: 'Enabled',
      },
      disabled: {
        notes: 'Fieldbus disabled value',
        message: 'Disabled',
      },
    },
  },
  component,
};
